export default "__VITE_ASSET__CyHqks4N__"